import { render, staticRenderFns } from "./ApproveButton.vue?vue&type=template&id=0c461da5&scoped=true&"
import script from "./ApproveButton.vue?vue&type=script&lang=js&"
export * from "./ApproveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c461da5",
  null
  
)

export default component.exports